require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-giovanni-buzzi.json") })
        }
      }, "path---interviste-giovanni-buzzi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-giovanni-buzzi!./.cache/json/interviste-giovanni-buzzi.json
// module id = 672
// module chunks = 231608221292675